// bank-misc-messages translations (English catalog).
window.PlummeI18n.register('en', {
  'r1b.guided.useStatementAmount': 'Use the amount from the statement ({amount})',
  'r1b.guided.checkedSuggestions': '{count} reviewed suggestions',
  'r1b.import.read': 'Read: {amount}',
  'r1b.misc.bankAmountIncl': 'Bank amount incl. {vat}',
  'r1b.misc.bankAmountExcl': 'Bank amount excl. {vat}',
  'r1b.misc.invoiceOption': '{number} · {customer} · {remaining} remaining',
  'r1b.posting.view': 'View',
  'r1b.inbox.uploadingAnalysing': 'Uploading and analysing',
  'r1b.surface.statementArchived': 'The bank statement has been reconciled and archived',
  'r1b.surface.archiveFailed': 'Could not archive the bank statement',
  'r1b.route.loadFailed': 'Could not load the page.',
  'r1b.route.loading': 'Loading the page...',
});
